import React from "react";
import MyReleases from "../../components/my-releases/my-releases.js";
import useTitle from "../../hooks/useTitle.js";
import { isLoggedIn } from "../../utils/auth.js";

export default function MyReleasesPage() {
  useTitle("My Releases");

  if (!isLoggedIn()) {
    window.location = '/';
    return null;
  }

  return <MyReleases></MyReleases>;
}
